import {
	IWfaSessionRow,
	TWfaSessionsResult
} from 'src/apps/dashboard/types/WfaDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { DashboardWfaSessionsQuery } from '../Sessions.generated';

export const transformTestsResults = (
	rawResults: DashboardWfaSessionsQuery
): TWfaSessionsResult => {
	const rows: IWfaSessionRow[] =
		rawResults.wfa_session_runs?.filter(returnNonNull).map((session) => ({
			sessionId: session.run_id,
			totalIssues: session.total_issues,
			criticalIssues: session.critical_issues,
			seriousIssues: session.serious_issues,
			runTime: session.run_time,
			sessionName: session.session_name,
			createdBy: session.user_name
		})) ?? [];

	let total = 0;
	if (rawResults.total?.length) {
		total = rawResults.total[0]?.run_id_count ?? 0;
	}

	let unfilteredTotal = 0;
	if (rawResults.unfiltered_total?.length) {
		unfilteredTotal = rawResults.unfiltered_total[0]?.run_id_count ?? 0;
	}

	return {
		rows,
		total,
		unfilteredTotal
	};
};
